import { ACCEPTED_DOCS_ID_TYPES, ACCEPTED_DOCS_TYPES } from "../../config";
import {
  DebouncedDateInput,
  DebouncedTextInput,
  Group,
  GroupItem,
  GroupTitle,
} from "ra-friendsofbabba";

import DocMediaInput from "./DocMediaInput";
import { Input } from "../../component/input";
import React from "react";
import moment from "moment";

const isLowerThenToday =
  (message = "ra.validation.is_not_lower_then_today") =>
  (value) => {
    if (!value || value.length === 0) {
      return undefined;
    }
    const date = moment(value);
    if (!date.isValid()) {
      return undefined;
    }
    const today = moment();
    return date.isAfter(today) ? message : undefined;
  };

const UserDocIDInput = ({ label, help, ...props }) => (
  <Group {...props} wrapper>
    <GroupTitle title={label} subTitle={help} />
    <Group>
      <GroupItem lg={3} md={3}>
        <Input
          isRequired
          maxLength={50}
          source="user.profile.doc_id"
          component={<DebouncedTextInput />}
        />
      </GroupItem>
      <GroupItem lg={3} md={3}>
        <Input
          isRequired
          maxLength={50}
          source="user.profile.doc_type"
          component={<DebouncedTextInput />}
        />
      </GroupItem>
      <GroupItem lg={3} md={3}>
        <Input
          isRequired
          maxLength={50}
          source="user.profile.doc_released_by"
          component={<DebouncedTextInput />}
        />
      </GroupItem>
      <GroupItem lg={3} md={3}>
        <Input
          isRequired
          source="user.profile.doc_release_date"
          validate={isLowerThenToday()}
          component={<DebouncedDateInput />}
        />
      </GroupItem>
    </Group>
    <Group>
      <GroupItem lg={12} md={12} sm={12} xs={12}>
        <DocMediaInput
          source="id_doc_media"
          title="filename"
          accept={ACCEPTED_DOCS_ID_TYPES.concat(ACCEPTED_DOCS_TYPES).join(",")}
        />
      </GroupItem>
    </Group>
  </Group>
);

export default UserDocIDInput;
